import { render, staticRenderFns } from "./zxdy.vue?vue&type=template&id=2b178262&scoped=true"
import script from "./zxdy.vue?vue&type=script&lang=js"
export * from "./zxdy.vue?vue&type=script&lang=js"
import style0 from "./zxdy.vue?vue&type=style&index=0&id=2b178262&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b178262",
  null
  
)

export default component.exports